<br />

@if (!loading) {
  <div style="display: grid; align-items: center; min-height: 40px">
    @if (nombreCliente !== '') {
      <h1 style="margin-right: 50px">{{ nombreCliente }}</h1>
      <div>
        <app-button
          matType="mat-mini-fab"
          color="primary"
          icon="visibility"
          tooltip="Detalles"
          ngClass="grid-item"
          (click)="notas()"
          style="margin-right: 4px"
        ></app-button>
        <app-button
          matType="mat-mini-fab"
          color="primary"
          icon="edit"
          tooltip="Editar"
          ngClass="grid-item"
          (click)="editar()"
          style="margin-right: 4px"
        ></app-button>
        <app-button
          matType="mat-mini-fab"
          color="primary"
          icon="account_tree"
          tooltip="Cambiar Cliente Padre"
          ngClass="grid-item"
          (click)="cambiarPadre()"
          style="margin-right: 4px"
        ></app-button>
        <app-button
          matType="mat-mini-fab"
          color="primary"
          icon="drive_file_move"
          tooltip="Mover Entidades a Otro Cliente"
          ngClass="grid-item"
          (click)="moverEntidades()"
          style="margin-right: 4px"
        ></app-button>
        <app-button
          matType="mat-mini-fab"
          color="warn"
          icon="delete"
          tooltip="Eliminar"
          ngClass="grid-item"
          (click)="eliminarConDialog()"
        ></app-button>
      </div>
    }
    <div style="justify-self: right; position: absolute">
      <app-button
        matType="mat-fab"
        icon="add"
        color="primary"
        (click)="crear()"
      ></app-button>
    </div>
  </div>
} @else {
  <app-loading
    text="Cargando información de clientes..."
    [diameter]="60"
  ></app-loading>
}

<figure class="highcharts-figure">
  <app-chart [options]="chartOptions" [style]="'display: block;'"></app-chart>
</figure>
